import React from 'react';
import {
  number, string, oneOf, object, oneOfType,
} from 'prop-types';
import Image from '../../shared/Image';

// Add sizes as needed
const SIZE_OPTIONS = [12, 16, 20, 24, 36, 48, 96];

/**
 * A square icon that resizes the  given image appropriately
 *
 * @param {*} param0
 */
const Icon = ({
  size,
  uri,
  width,
  height,
  ...rest
}) => (
  <Image
    source={{
      uri,
      height: height || size,
      width: width || size,
    }}
    resizeMode="contain"
    {...rest}
  />
);

Icon.propTypes = {
  size: oneOf(SIZE_OPTIONS),
  uri: string.isRequired,
  width: oneOfType([number, string]),
  height: oneOfType([number, string]),
  style: object,
};

Icon.defaultProps = {
  size: 12,
  width: null,
  height: null,
  style: null,
};

export default Icon;
